import { render } from "./UserPopover.vue?vue&type=template&id=3e00f50c&bindings={\"user\":\"setup\",\"isDark\":\"setup\",\"logout\":\"setup\",\"showAuthModal\":\"setup\"}"
import script from "./UserPopover.vue?vue&type=script&lang=js"
export * from "./UserPopover.vue?vue&type=script&lang=js"
script.render = render

export default script